module.exports = __webpack_public_path__ + "static/media/nikhil.347f65df.jpg";